<template>
  <div class="retrieve-tab-display-book">
    <div class="header">
      <div class="tab-button-group">
        <el-radio-group v-model="tabIndex">
          <el-radio-button :label='1' :disabled="originDisable"><img :src="tabIndex === 1? 'static/images/icons/image-active.png' : 'static/images/icons/image.png'">原文图像</el-radio-button>
          <el-radio-button :label='2' :disabled="textDisable"><img :src="tabIndex === 2? 'static/images/icons/text-active.png' : 'static/images/icons/text.png'">横版文字</el-radio-button>
          <el-radio-button :label='3' :disabled="xmlDisable" @click.native="changeTab3($event)"><img :src="tabIndex === 3? 'static/images/icons/image-text-active.png' : 'static/images/icons/image-text.png'">{{tabName}}</el-radio-button>
          <el-radio-button :label='4' :disabled="pdfDisable"><img :src="tabIndex === 4? 'static/images/icons/pdf-active.png' : 'static/images/icons/pdf.png'">PDF图像</el-radio-button>
        </el-radio-group>
      </div>
      <div class="display-button-group">
        <template v-if="tabIndex === 1 || tabIndex === 3||tabIndex === 4" >
          <img src="../assets/images/icons/full-screen.png"
               class="full-screen-button" :class="isFullscreen?'exit-fullscreen':'fullscreen'" @click="fullscreen">
          <div class="recovery-button" @click="changeZoom(0)" v-if="tabIndex === 1 || tabIndex === 3">1:1</div>
          <img src="../assets/images/icons/zoom-up.png" v-if="tabIndex === 1 || tabIndex === 3"
               class="zoom-up-button" @click="changeZoom(10)">
          <img src="../assets/images/icons/zoom-down.png" v-if="tabIndex === 1 || tabIndex === 3"
               class="zoom-down-button" @click="changeZoom(-10)">
        </template>
        <input v-model.lazy="currentPage">
        <div>/{{total}}</div>
      </div>
    </div>
    <div class="display" v-if="tabIndex === 1" key="tab1">
        <img class="leftarrow"
           src="../assets/images/leftarrow.png" @click="reducePage()">
      <div class="viewer">
        <!-- <div v-show="!image">本页暂无原版图像</div> -->
        <viewer ref="imageViewer"
                style="height: 100%"
                v-show="image">
          <template>
            <img :src="image" class="origin-image"/>
          </template>
        </viewer>
      </div>
      <img class="rightarrow"
           src="../assets/images/rightarrow.png" @click="addPage()">
    </div>
    <div class="display" v-show="tabIndex !== 1">
      <img v-if=" tabIndex === 3"
           class="leftarrow"
           src="../assets/images/leftarrow.png" @click="reducePage()">
      <!-- <div class="viewer"
           v-if="tabIndex === 3" key="viewer">
        <viewer ref="imageViewer" id="imageViewer"
                style="height: 63%" >
          <template>
            <img :src="image" id="imageOrigin"
                 style="display: none;" />
          </template>
        </viewer>
      </div>
      <div class="divider" id="divider"
           v-show="tabIndex === 3"></div> -->
      <div class="viewer"
           v-show="tabIndex === 3">
        <div id="sDivId" class="sDivId"></div>
      </div>
      <div v-show="tabIndex === 2" class="textarea">
        <span :title="isOcrText ? '该文本由OCR自动生成，未经人工校对' : ''">
          {{ text }}
        </span>
      </div>
           <!-- <span>{{text}}</span> -->
           <!-- <div v-show="tabIndex === 4&&!url">本页暂无pdf图像</div> -->

           <div v-show="tabIndex === 4" class="pdf" style=" position: relative;" @contextmenu.prevent.capture>
               <iframe
      id="pdfIframe" :src="url+'#toolbar=0'" type=""
              class="pdf"
              ref="myIframe"
              frameborder="0"
              ></iframe>
            </div>
      <img v-if=" tabIndex === 3"
           class="rightarrow"
           src="../assets/images/rightarrow.png" @click="addPage()">
    </div>
    <div class="pagination">
      <div class="first-page-button"
           @click="gotoFirstPage">首页</div>
      <el-pagination background
                     layout="prev, pager, next,jumper"
                     :page-size="1"
                     :pager-count="6"
                     prev-text="上一页"
                     next-text="下一页"
                     :current-page.sync="currentPage"
                     :total="total"
                     v-if="bPageShow">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {loadXMLPages, ParseXml, ChangeWordSize} from '../assets/showvpage22.js'
import {ParseXml2, ChangeWordSize2} from '../assets/showvpage2.js'
import screenfull from 'screenfull'
import { convertTraditionalStatus } from '@/utils/s_t_convert.js'
export default {
  name: 'RetrieveTabDisplayBook',
  props: {
    bookId: {
      type: String,
      required: true
    },
    bookName: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    isFree: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    traditional: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tabIndex: 1,
      text: '', // 文本文字
      image: '', // 图片链接
      photo: [],
      url: '', // pdf链接
      xmlData: '',
      inputPage: 1,

      tbCount: 0,
      pdfCount: 0,
      originCount: 0,
      xmlList: '',
      changePage: 1,
      originDisable: true,
      originPath: '',
      pdfDisable: true,
      textDisable: true,
      xmlDisable: true,
      bPageShow: true,
      userId: '',
      defaultPermission: 40,
      flag: '',
      tabName: '图文对照',
      type: 1,
      isOcrText: false
    }
  },
  mounted () {
    this.userId = localStorage.getItem('userId')
    if (localStorage.getItem('isLogined') === true) {
      this.defaultPermission = Number(localStorage.getItem('defaultPermission'))
    }
    // 屏蔽鼠标右键
    document.oncontextmenu = function () {
      // alert('禁止右键');
      return false
    }
    document.addEventListener('keydown', function (e) {
      if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault()
      }
    })
    // window.onload = function () {
    //   document.getElementById('pdfIframe').contentDocument.oncontextmenu = function () {
    //     return false
    //   }
    // }
    // window.addEventListener('beforeunload', this.preventDownload)
    // this.$refs.myIframe.onload = () => {
    //   const iframeDocument = this.$refs.myIframe.contentWindow.document
    //   iframeDocument.addEventListener('contextmenu', (event) => {
    //     event.preventDefault()
    //   })
    // }
    // this.saveExpenseLog()
    this.preventDownload()
  },
  methods: {
    preventDownload () {
      if (window.event) {
        window.event.preventDefault()
        window.event.returnValue = '下载功能已被禁用'
      }
    },
    changeTab3 (el) {
      if (el.target.tagName === 'INPUT') {
        // document.body.removeChild(document.getElementById('sDivId'))
        this.rebuildViewer()
        this.getXml()
        this.$forceUpdate()
        this.tabIndex = 3
      }
    },
    getIsCustomByRecordId () {
      this.$http({
        method: 'get',
        url: 'retrieve/book/getIsCustomByRecordId?recordId=' + this.bookId + '&userId=' + localStorage.getItem('userId')
      }).then(res => {
        if (res.data.status === 200) {
          this.bookCustom = res.data.data
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    getImage () {
      this.$http({
        method: 'get',
        url: '/retrieve/page/getImage?bookId=' + this.bookId + '&page=' + this.currentPage,
        // 例:{uploadUrl:uploadUrl},传入ofd格式的下载文件url
        responseType: 'blob' // 设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置，否则pdf会展示空白！！！
      }).then(res => {
        const binaryData = []
        binaryData.push(res.data)
        const url = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'image/jpg' })
        )
        this.photo.push('url', url)
        this.image = url
        setTimeout(() => {
          this.updateViewer()
        }, 10)
        // this.viewVisible = true // 当前页弹框打开
        // 新页面打开
        //   window.open(url)
        // this.$forceUpdate()
      }).catch(function (error) {
        this.image = ''
        console.log(error)
      })
    },
    getPDF () {
    // 在created中进行判断使用
      // 普通浏览器中关闭必须是自动打开才可以/手动打开的网址不能执行关闭，只能改变网址清空
      var ua = window.navigator.userAgent.toLowerCase()
      // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        console.log('这里是微信浏览器')
      } else {
        this.$http({
          method: 'GET',
          url: '/retrieve/page/getPdf?bookId=' + this.bookId + '&page=' + this.currentPage,
          // data: params, // 例:{uploadUrl:uploadUrl},传入ofd格式的下载文件url
          responseType: 'blob' // 设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置，否则pdf会展示空白！！！
        }).then(res => {
          const binaryData = []
          binaryData.push(res.data)
          const url = window.URL.createObjectURL(
            new Blob(binaryData, { type: 'application/pdf' })
          )
          this.url = url
          this.viewVisible = true // 当前页弹框打开
        }).catch(function (error) {
          this.url = ''
          console.log(error)
        })
      }
    },
    getText () {
      this.isOcrText = false
      let params = new URLSearchParams()
      let url = 'retrieve/page/getText'
      params.append('bookId', this.bookId)
      params.append('page', this.currentPage)
      this.$http.post(url, params).then((res) => {
        this.$emit('get-data')
        console.log('res', res.data.data)
        if (res.data.status === 200) {
          var info = res.data.data
          if (!info.textAll) {
            if (info.text === '') {
              this.text = '本页暂无横板文字'
              this.textDisable = true
            } else {
              if (info.textSource === 1) {
                this.isOcrText = true
              }
              this.text = info.text
              this.textDisable = false
            }
          } else {
            this.text = info.textAll
            this.textDisable = false
          }
          this.originDisable = !info.originPath
          this.originPath = info.originPath
          var ua = window.navigator.userAgent.toLowerCase()
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            this.pdfDisable = true
          } else {
            this.pdfDisable = !info.pdfPath
          }

          //   this.textDisable = !info.text

          if (info.originPath) {
            this.getImage()
          }
          if (info.pdfPath) {
            this.getPDF()
          }
          setTimeout(() => {
            this.getXml()
          }, 500)

          //   this.text = this.text === '' ? info.textAll : this.text
          if (this.text) {
            this.$nextTick(() => { convertTraditionalStatus(['.display .textarea'], this.traditional) })
          }
        } else {
          this.text = ''
          this.$message({
            type: 'error',
            message: res.data
          })
        }
        // document.querySelector('.display .textarea').innerHTML = this.text
      })
    },
    getXml () {
    //   let url = '/retrieve/page/getXML?bookId=' + this.bookId + '&page=' + this.currentPage
    //   this.xmlDisable = false
    //   setTimeout(() => {
    //     if (this.originPath) {
    //       let tempArray = this.originPath.split('.')[0].split('/')
    //       var path = this.bookId + '/' + tempArray[0] + '/image/' + tempArray[1]
    //       ParseXml(url, 3, path, this.image)
    //       var objDivRebuildPage = document.getElementById('sDivId')
    //       if()
    //       //   ParseXml2(url)
    //       console.log('path', path)
    //     }
    //   }, 500)

    //   this.xmlList = []
      this.$http({
        method: 'GET',
        url: '/retrieve/page/getXML?bookId=' + this.bookId + '&page=' + this.currentPage
      }).then(res => {
        console.log('xml', res)
        this.$emit('get-data')
        if (res.status === 400) {
          this.xmlDisable = true
        } else {
          this.xmlDisable = false
          this.xmlList = res.data

          if (this.originPath) {
            let tempArray = this.originPath.split('.')[0].split('/')
            var path = this.bookId + '/' + tempArray[0] + '/image/' + tempArray[1]
            console.log('path', path)
            let maxid = this.GetOnePara(this.xmlList, 'maxid', '0')
            console.log('maxid', maxid)
            // setTimeout(() => {
            if (maxid == 0) {
              this.type = 1
              this.tabName = '图文对照'
              ParseXml(this.xmlList, 3, path, this.image)
            } else {
              this.type = 2
              this.tabName = '竖版文字'
              ParseXml2(this.xmlList, this.bookName, this.currentPage)
            }
            // }, 100)
          }
          console.log('image', this.image)
          try {

          } finally {
            convertTraditionalStatus(['#sDivId'], this.traditional)
          }
        }
      }).catch(function (error) {
        // deleteData() // 清空原来的内容
        console.log(error)
      })
    },
    GetOnePara (sString, sPara, sDefault) {
      var iPos
      var sRet = ''
      iPos = sString.indexOf(sPara + '=')
      if (iPos >= 0) {
        sRet = sString.substr(iPos + sPara.length + 1)
        iPos = sRet.indexOf(' ')
        if (iPos > 0) { sRet = sRet.substr(0, iPos) }
        iPos = sRet.indexOf('/>')
        if (iPos > 0) { sRet = sRet.substr(0, iPos) }
        iPos = sRet.indexOf('>')
        if (iPos > 0) { sRet = sRet.substr(0, iPos) }
        if (sRet.length > 0) {
          if (sRet.substr(0, 1) == '"' || sRet.substr(0, 1) == "'") { sRet = sRet.substr(1) }
        }
        if (sRet.length > 0) {
          if (sRet.substr(sRet.length - 1) == '"' || sRet.substr(sRet.length - 1) == "'") { sRet = sRet.substr(0, sRet.length - 1) }
        }
      }
      if (sRet == '') { sRet = sDefault }
      return sRet
    },
    getDetail () {
      this.getText()
      //   this.getXml()
      this.bPageShow = false
      this.$emit('changePage', this.currentPage)
      this.$nextTick(() => {
        this.bPageShow = true
      })
    },
    addBookLog () {
      if (this.userId) {
        let params = new URLSearchParams()
        let url = 'retrieve/bookLog/addBookLog'
        params.append('userId', Number(localStorage.getItem('userId')))
        params.append('bookId', this.bookId)
        params.append('page', this.currentPage)
        this.$http.post(url, params).then((res) => {
        }, (err) => {
          this.$message({
            type: 'error',
            message: err.data.message
          })
        })
      }
    },
    checkPermission () {
      this.defaultPermission = Number(localStorage.getItem('defaultPermission'))
      switch (Number(this.defaultPermission)) {
        case 10:
        //   var time = Number(Date.parse(localStorage.getItem('memberDeadline'))) - Number(Date.parse(new Date()))
        //   if (time > 0) {
          this.getDetail()
          this.addBookLog()
          this.flag = true
          //   } else {
          // this.$message({
          //   type: 'error',
          //   message: '已过期'
          // })
          // this.flag = false
          //   }
          break
        case 20:
          console.log('22')
          this.saveExpenseLog()
          break
        case 30:
        //   this.$message({
        //     type: 'error',
        //     message: '仅可试读前10页'
        //   })
          this.$confirm('仅可试读前10页', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {

          })
          this.flag = false
          break
        case 40:
          console.log('30', this.defaultPermission)
          this.$confirm('请登录后再试', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {

          })
          this.flag = false
          break
      }
    },
    saveExpenseLog () {
      console.log('zhix')
      const params = new URLSearchParams()
      const url = 'retrieve/expense/saveExpenseLog'
      params.append('userId', localStorage.getItem('userId'))
      params.append('bookId', this.bookId)
      params.append('page', this.currentPage)
      this.$http.post(url, params).then((res) => {
        // console.log(res)
        if (res.data.status === 200 && res.status === 200) {
          console.log('res', res)
          this.getDetail()
          this.addBookLog()
          this.flag = true
        } else {
          this.$message({
            type: 'error',
            message: res.data
          })
        }
      })
    },
    inputChange () {
      this.currentPage = this.inputPage
    },
    gotoFirstPage () {
      this.currentPage = 1
    },
    reducePage () {
      this.currentPage = this.currentPage - 1 > 0 ? this.currentPage - 1 : 1
    },
    addPage () {
      this.currentPage = this.currentPage + 1 > this.total ? this.total : this.currentPage + 1
    },
    changeCurrentPage () {
      var page = this.changePage > this.total ? this.total : this.changePage
      setTimeout(() => {
        this.currentPage = page
      }, 50)
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    rebuildViewer () {
      this.$refs.imageViewer.rebuildViewer()
    //   this.$refs.textViewer.rebuildViewer()
    },
    updateViewer () {
      this.$refs.imageViewer.$viewer.update()
      this.$refs.imageViewer.$viewer.show()
    //   this.$refs.textViewer.$viewer.update()
    //   this.$refs.textViewer.$viewer.show()
    },
    fullscreen () {
      if (!screenfull.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle()
    },
    changeZoom (size) {
      if (this.tabIndex === 1) {
        if (size < 0) {
          this.$refs.imageViewer.$viewer.zoom(-0.1, true)
        } else if (size > 0) {
          this.$refs.imageViewer.$viewer.zoom(0.1, true)
        } else {
          this.$refs.imageViewer.$viewer.reset()
        }
      } else {
        try {
          this.type === 1 ? ChangeWordSize(size) : ChangeWordSize2(size)
        } catch (e) {
          console.error(e)
        } finally {
          this.convertAllTraditionalStatus()
        }
      }
    },
    changeTabIndex (index) {
      this.tabIndex = index
    },
    convertAllTraditionalStatus () {
      convertTraditionalStatus(['.display .textarea', '#sDivId'], this.traditional)
    }
  },
  watch: {
    bookId (newvalue, oldValue) {
      if (newvalue != oldValue) {
        if (this.userId) {
          this.getIsCustomByRecordId()
        }
        if (this.currentPage <= 10 || this.isFree === 1 || this.bookCustom === true) {
          this.getDetail()
          this.addBookLog()
        } else {
          this.checkPermission()
        }
      }
    },
    currentPage: {
      handler (newValue, oldValue) {
        if (newValue != oldValue) {
          if (this.defaultPermission && this.defaultPermission > 0) {
            // console.log('this.isFree', this.isFree)
            if (this.currentPage <= 10 || this.isFree === 1 || this.bookCustom === true) {
            //   console.log('<10')
              this.addBookLog()
              this.getDetail()
            } else {
            //   console.log('>=10')
              this.checkPermission()
              if (this.flag === false) {
                this.currentPage = oldValue
              }
            }
          }
        }
      }
    },
    tabIndex (newVal) {
      this.rebuildViewer()
      if (newVal === 4) {
        window.onload = function () {
          document.getElementById('pdfIframe').contentDocument.oncontextmenu = function () {
            alert('本站禁止此操作')
            return false
          }
        }
      }
    },
    traditional () {
      this.convertAllTraditionalStatus()
    },
    viewerHeight () {
      loadXMLPages(this.xmlList, 3)
    }
  }
}
</script>

<style scoped>
* {
  color: #634c37;
  font-size: 16px;
}
.sDivId{
  position: relative;
  width:780px;
  height:605px !important;
  border:solid 0px #FF0000;
  overflow:auto;
}
.div_block_bookname{
     color: #000000;
    font-family: PMingLiu-ExtB,SimSun-ExtB,SimSun,宋体;
    text-align: center;
    border: solid 0px #000000;
}

.sDivId::-webkit-scrollbar {
  background-color: #f5eee8;
  width: 8px;
  height:8px;
}

.sDivId::-webkit-scrollbar-thumb {
  background-color: #9e5c1d;
  border-radius: 0;
  border-style: dashed;
  border-color: transparent;
  border-width: 3px;
  background-clip: padding-box;
}

.sDivId::-webkit-scrollbar-thumb:hover {
    border-width: 0.5px;
}
.retrieve-tab-display-book {
  background-color: #ffffff;
  padding: 14px 14px 0px 14px;
  display: flex;
  flex-direction: column;
  height: 710px;
}

.header {
  height: 35px;
  background-color: #f7f6f5;
  display: flex;
  align-items: center;
}

.tab-button-group {
  flex-grow: 1;
  display: flex;
  justify-content: center;
}
.origin-image{
    position: relative;
    top:50%;
    transform: translateY(-50%);
    max-height: 600px;
    max-width: 538px;
}
.tab-button-group img {
  width: 22px;
  margin-right: 5px;
}

.tab-button-group
  >>> .el-radio-button__orig-radio:checked
  + .el-radio-button__inner {
  background-color: #9e5c1d;
  box-shadow: 0px 0px 0px white;
  color: white;
}

.tab-button-group >>> .el-radio-button__inner {
  width: 109px;
  height: 30px;
  background-color: #f7f6f5;
  border-radius: 0px;
  padding: 0px;
  border: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-button-group >>> .el-radio-button__inner:hover {
  color: #634c37;
}

.display-button-group {
  width: 221px;
  margin-right: 18px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.display-button-group img {
  height: 26px;
  cursor: pointer;
}

.full-screen-button:active {
  content: url('../assets/images/icons/full-screen-active.png');
}
.full-screen-button{
  margin-right:4px
}
.recovery-button {
  border: 1px solid #9e5c1d;
  box-sizing: border-box;
  width: 60px;
  height: 26px;
  margin: 0px 3px 0px 0px;
  text-align: center;
  cursor: pointer;
}

.recovery-button:active {
  background-color: #f2eae1;
}

.zoom-up-button:active {
  content: url('../assets/images/icons/zoom-up-active.png');
}

.zoom-down-button {
  margin: 0px 5px 0px 4px;
}

.zoom-down-button:active {
  content: url('../assets/images/icons/zoom-down-active.png');
}

.display-button-group input {
  border: 1px solid #9e5c1d;
  box-sizing: border-box;
  width: 38px;
  height: 26px;
  text-align: center;
  padding: 5px 0px 0px 0px;
  margin-right: 5px;
}

.display-button-group input:focus {
  outline: none;
}

.display {
  flex-grow: 1;
  border-bottom: 1px solid #f9f5f2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0px 10px 0px;
}

/* .display img {
  height: 50px;
} */

.viewer {
  flex-grow: 1;
  /* padding:50% 0; */
  align-self: stretch;
  /* vertical-align: middle; */
  /* height: 621px;*/
  max-height: 600px;
  /* max-width: 538px; */
  /* display:flex */
}
.viewer2 {
  /* align-self: stretch; */
  /* vertical-align: middle; */
  height: 621px;
  /* display:flex */
}
.viewer >>> .viewer-backdrop {
  background-color: white;
}

.divider {
  width: 1px;
  height: 593px;
  background-color: #f5eee8;
  margin: 0px 5px;
}

.ocr-warning {
  color: red;
  font-size: 12px;
}

.textarea {
  overflow-y: auto;
  height: 580px;
  padding: 27px 40px 0px 42px;
  text-align: left;
  line-height: 36px;
  width: 0px;
  flex-grow: 1;
}

.pdf {
  width: 100%;
  height: 100%;
}

.leftarrow:hover {
  content: url('../assets/images/leftarrowon.png');
}

.rightarrow:hover {
  content: url('../assets/images/rightarrowon.png');
}

.leftarrow:active {
  content: url('../assets/images/leftarrowactive.png');
}

.rightarrow:active {
  content: url('../assets/images/rightarrowactive.png');
}

.pagination {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.first-page-button {
  box-sizing: border-box;
  cursor: pointer;
}

.first-page-button,
.pagination >>> .el-pagination.is-background .el-pager li,
.pagination >>> .el-pagination.is-background .btn-prev,
.pagination >>> .el-pagination.is-background .btn-next {
  color: #634c37;
  background-color: white;
  border: 1px solid #d2cdc8;
  height: 26px;
}

.pagination >>> .el-pagination.is-background .el-pager li {
  line-height: 24px;
}

.first-page-button,
.pagination >>> .el-pagination.is-background .btn-prev,
.pagination >>> .el-pagination.is-background .btn-next {
  width: 60px;
}

.first-page-button:active,
.pagination >>> .el-pagination.is-background .btn-prev:active,
.pagination >>> .el-pagination.is-background .btn-next:active,
.pagination
  >>> .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  color: white;
  background-color: #9e5c1d;
}
.originImage{

}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveTabDisplayBook.vue